import { createMongoAbility, type MongoAbility } from "@casl/ability";
import {
  AbilityProvider,
  Can as CaslCan,
  type CanProps,
  useAbility as useCaslAbility,
} from "@casl/react";
import {
  type AdminRole,
  type PermissionAction,
  type PermissionSubject,
  ROLE_PERMISSIONS,
} from "@milqit/shared-types";
import type { ReactNode } from "react";

/**
 * What the signed-in admin may do, from the same table the API enforces
 * (`ROLE_PERMISSIONS` in @milqit/shared-types). Hiding a button here is a courtesy; the API still
 * refuses anything the role can't do.
 */
export type AppAbility = MongoAbility<[PermissionAction, PermissionSubject]>;

export const abilityFor = (role: AdminRole): AppAbility =>
  createMongoAbility<AppAbility>(ROLE_PERMISSIONS[role]);

/** Provides the signed-in admin's ability to everything below it. */
export { AbilityProvider };

export const useAbility = () => useCaslAbility<AppAbility>();

/** `<Can I="create" a="Product">…</Can>` renders its children only when allowed. */
export const Can = CaslCan as (props: CanProps<AppAbility>) => ReactNode;
